import { createFileRoute } from "@tanstack/react-router";
import { PageLoading } from "~/components/PageLoading";
import { trpc } from "~/utils/trpc.client";
import { ReportEditor } from "~/app/(new)/[teamId]/students/[studentId]/reports/[reportId]/ReportEditor";
import { ReportTypePicker } from "~/app/(new)/[teamId]/students/[studentId]/reports/[reportId]/ReportTypePicker";

export const Route = createFileRoute(
  "/_authed/$teamId/students/$studentId/reports/$reportId/",
)({
  component: StudentReportPage,
});

function StudentReportPage() {
  const { studentId, reportId } = Route.useParams();

  // getReportTypeByReportId can fail (no report type) — fail fast and fall back.
  const reportTypeQuery = trpc.reportTypes.getReportTypeByReportId.useQuery(
    { reportId },
    { retry: false },
  );
  const reportQuery = trpc.reports.getReportById.useQuery({ reportId });
  const studentQuery = trpc.students.getStudent.useQuery({ id: studentId });

  if (!reportQuery.data || !studentQuery.data || reportTypeQuery.isLoading) {
    return (
      <div className="relative h-full whitespace-pre-wrap p-4">
        <PageLoading />
      </div>
    );
  }

  const reportType = reportTypeQuery.data ?? null;
  const report = reportQuery.data;
  const student = studentQuery.data;

  return (
    <div className="relative h-full whitespace-pre-wrap p-4">
      {reportType ? (
        <ReportEditor
          report={report}
          reportType={reportType}
          student={student}
        />
      ) : (
        <ReportTypePicker report={report} />
      )}
    </div>
  );
}
